/**
 * Step 5: Existing Regulatory Universe
 * Option to import existing regulatory universe
 */

import React from 'react';
import { Globe } from '@phosphor-icons/react';
import { ToggleField, StepSection, InfoCard, FileUpload } from './SharedComponents';

const Step5RegulatoryUniverse = ({ formData, updateField }) => {
  return (
    <StepSection
      title="Existing Regulatory Universe"
      description="Do you have an existing regulatory universe to import?"
      icon={Globe}
    >
      <ToggleField
        label="I have an existing regulatory universe"
        description="If yes, you can import your existing regulatory mapping"
        checked={formData.has_existing_universe || false}
        onChange={(v) => updateField('has_existing_universe', v)}
        testId="existing-universe-toggle"
      />
      
      {formData.has_existing_universe && (
        <div className="space-y-4 p-4 bg-background-surface rounded-lg border border-border">
          <ToggleField
            label="Import and continue with existing universe"
            description="AURA will review and enhance your existing regulatory mapping"
            checked={formData.continue_existing_universe || false}
            onChange={(v) => updateField('continue_existing_universe', v)}
            testId="continue-universe-toggle"
          />
          
          {formData.continue_existing_universe && (
            <FileUpload
              label="Upload Regulatory Universe Document"
              onUpload={(file) => updateField('existing_universe_file', file)}
              uploadedFile={formData.existing_universe_file}
              accept=".xlsx,.xls,.csv,.pdf"
              helpText="Excel, CSV, or PDF format. NAVI will analyze and map to AURA framework."
              testId="universe-upload"
            />
          )}
          
          <InfoCard variant="info" title="Universe Import">
            NAVI will analyze your existing regulatory universe and:
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Map existing regulations to the AURA canonical framework</li>
              <li>Identify gaps based on your business profile</li>
              <li>Suggest additional regulations that may apply</li>
              <li>Flag any outdated or repealed legislation</li>
            </ul>
          </InfoCard>
        </div>
      )}
      
      {!formData.has_existing_universe && (
        <InfoCard variant="success" title="New Regulatory Universe">
          AURA will generate a comprehensive regulatory universe based on your intake responses. 
          The Applicability Engine will determine:
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Primary legislation applicable to your organization</li>
            <li>Subordinate regulations, rules, and directives</li>
            <li>FIC Schedule 1 specific requirements</li>
            <li>Industry-specific regulatory obligations</li>
          </ul>
        </InfoCard>
      )}
    </StepSection>
  );
};

export default Step5RegulatoryUniverse;
